import { useQuery } from "react-query"
import dataAPI from "../../services/dataAPI"

export default function useLastCredit(device_name?: string) {
  const creditQuery = useQuery({
    queryKey: ['credit-last', device_name],
    queryFn: () => {
      const filterWithDevice = { device_name: device_name || '' }
      return dataAPI.getLastCreditSingleCounter(filterWithDevice)
    },
    enabled: !!device_name
  })

  const formatValue = (value: number | undefined, decimals: number = 2): string => {
    if (value === undefined || value === null) return 'NA'
    return Number(value).toFixed(decimals)
  }

  const getStatus = (value: number | undefined): 'ok' | 'warning' | 'danger' => {
    if (value === undefined || value === null) return 'danger'
    // Crédit: > 10kWh = ok, 5-10kWh = warning, < 5kWh = danger
    if (value >= 10) return 'ok'
    if (value >= 5 && value < 10) return 'warning'
    return 'danger'
  }

  return {
    creditQuery: {
      data: creditQuery.data,
      isLoading: creditQuery.isLoading,
      isSuccess: creditQuery.isSuccess,
      isError: creditQuery.isError,
      error: creditQuery.error,
      refetch: creditQuery.refetch,
      isRefetching: creditQuery.isRefetching
    },
    creditValue: creditQuery.data?.[0]?.Value,
    formattedCredit: formatValue(creditQuery.data?.[0]?.Value, 2),
    creditStatus: getStatus(creditQuery.data?.[0]?.Value),
    creditTime: creditQuery.data?.[0]?.Time,
    isLoading: creditQuery.isLoading
  }
}

